var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSoundXFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 25.058 25.059",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#425061}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.529 1.175C6.261 1.182 1.182 6.261 1.175 12.529c.007 6.268 5.086 11.348 11.354 11.355 6.268-.007 11.348-5.087 11.355-11.355-.008-6.268-5.087-11.347-11.355-11.354z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-sound-x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    className: "st1",
    d: "M12.529 25.059C5.612 25.051.008 19.446 0 12.529.008 5.613 5.613.008 12.529 0c6.916.008 12.521 5.613 12.529 12.529-.008 6.917-5.612 12.522-12.529 12.53zm0-23.884C6.261 1.182 1.182 6.261 1.175 12.529c.007 6.268 5.086 11.348 11.354 11.355 6.268-.007 11.348-5.087 11.355-11.355-.008-6.268-5.087-11.347-11.355-11.354z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    className: "st1",
    d: "M18.251 12.553l1.77-1.77a.945.945 0 000-1.138.77.77 0 00-1.012 0l-1.77 1.77-1.9-1.77a.77.77 0 00-1.012 0 .77.77 0 000 1.012l1.77 1.77-1.77 1.77a.77.77 0 000 1.012.957.957 0 00.506.253.964.964 0 00.506-.253l1.77-1.77 1.77 1.77a.964.964 0 00.506.253.964.964 0 00.506-.253.77.77 0 000-1.012l-1.64-1.644z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    className: "st1",
    d: "M12.937 17.45V7.494a.7.7 0 00-.379-.632.692.692 0 00-.759.126l-4.047 3.288h-2.15a.817.817 0 00-.759.759v2.908a.817.817 0 00.759.759h2.15l3.966 3.348a.713.713 0 00.504.207.715.715 0 00.716-.7c.006.001-.001-.107-.001-.107z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundXFill);
export default __webpack_public_path__ + "static/media/icon-sound-X_fill.c6f1c0ef.svg";
export { ForwardRef as ReactComponent };